import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
//import { DokumentiService } from '../pages/dokumenti/dokumenti.services';
import { PregledIzdatniceService } from '../pages/pregled-izdatnice/pregled-izdatnice.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfIzdatnicaSirovinaZavrseniService {
  constructor(private service: PregledIzdatniceService, private authService: AuthService) {}

  pdfIzdatnicaSirovinaZavrseno(data) {
    console.log('DATA:  ', data.data);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let signatureLine = {
      table: {
        widths: ['100%'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    this.service
      .dohvatiJednuIzdatnicu({
        idkorisnik: localStorage.getItem('idsecuser'),
        idfirma: localStorage.getItem('firma'),
        pz_id: data.data.pz_id,
      })
      .subscribe((res) => {
        // console.log('RES PRIJE IF:  ', res);
        if (res.success == true) {
          console.log('RES POSLIJE IF:  ', res);

          let ct = [];

          ct.push({
            text: 'PEKAR d.o.o.',
            style: 'title',
          });

          ct.push({
            text: 'Obrtnička ulica 5 \n 32100 Vinkovci',
            style: 'subtitle',
            margin: [0, 0, 0, 15],
          });

          ct.push({
            columns: [
              {
                table: {
                  widths: [200],
                  body: [
                    [
                      {
                        table: {
                          body: [
                            [
                              {
                                text: 'Skladište:',
                                style: 'details',
                                bold: true,
                              },
                            ],
                            [
                              {
                                text: [
                                  data.data.po_sifra +
                                    ' ' +
                                    data.data.po_naziv +
                                    '\n',
                                ],
                                style: 'tableTitle',
                              },
                            ],
                            [
                              {
                                text: ['Smjena: ' + data.data.smjena_idsmjena + '\n'],
                                style: 'details',
                              },
                            ],
                            [
                              {
                                text: ['Linija: ' + data.data.li_naziv + '\n\n'],
                                style: 'details',
                              },
                            ],
                          ],
                        },
                        layout: 'noBorders',
                      },
                    ],
                  ],
                },
              },
              {
                text: [
                  { text: 'Datum: ', style: 'boldRight' },
                  data.data.datumformat + ' \n',
                  { text: 'Radni nalog: ', style: 'boldRight' },
                  data.data.nl_broj + ' \n',
                  { text: 'Broj dokumenta: ', style: 'boldRight' },
                  data.data.pz_id,
                ],
                style: 'details',
                lineHeight: '1.2',
              },
            ],
          });

          ct.push({
            text: 'Izdatnica sirovina: ' + data.data.pz_id,
            style: 'mainTitle',
            alignment: 'center',
            margin: [0, 30, 0, 30],
          });

          ct.push({
            table: {
              widths: [15, 40, 40, 200, 20, 50, 35, 52],
              body: [
                [
                  'RB',
                  'Šifra',
                  'LOT',
                  'Naziv artikla',
                  'Jed.',
                  'Količina',
                  'Cijena',
                  'Vrijednost',
                ],
              ],
            },
            layout: 'lightHorizontalLines',
          });

          ct.push(hLine);
          let n = 1;
          let vrijednost = 0;

          for (let stavka of res.data) {
            vrijednost += Number(stavka.ps_izlaz * stavka.ps_izlazc);
            console.log('VRIJEDNOST:  ', vrijednost);

            ct.push({
              table: {
                widths: [15, 40, 40, 200, 20, 50, 35, 52],
                body: [
                  [
                    { text: n++ + '.' },
                    { text: stavka.ar_sifra },
                    { text: stavka.ar_lot },
                    { text: stavka.ar_naziv },
                    { text: stavka.jedinicamjere_JM_SIFRA },
                    { text: stavka.ps_izlaz, alignment: 'right' },
                    { text: stavka.ps_izlazc, alignment: 'right' },
                    { text: this.konvertiraj(stavka.ps_izlaz * stavka.ps_izlazc), alignment: 'right' },
                  ],
                ],
              },
              layout: 'lightHorizontalLines',
            });
          }

          ct.push(hLine);
          ct.push({
            table: {
              widths: [455, 100],
              body: [
                [
                  {
                    text: 'UKUPNO',
                    style: 'tableFooter',
                    margin: [30, 0, 0, 0],
                  },
                  {
                    text: this.konvertiraj(vrijednost) + ' €',
                    style: 'tableFooter',
                    alignment: 'right'
                  },
                ],
              ],
            },
            layout: 'noBorders',
          });

          ct.push({
            absolutePosition: { x: 15, y: 700 },
            columns: [
              [{ text: 'Robu izdao:', margin: [0, 60, 0, 30] }, signatureLine],
              [],
              [],
              [
                {
                  text: 'Robu preuzeo:',
                  alignment: 'right',
                  margin: [0, 60, 0, 30],
                },
                signatureLine,
              ],
            ],
          });

          var dd = {
            info: {
              title: 'Završena izdatnica sirovina: ' + data.data.pz_id,
            },
            content: ct,
            pageMargins: 15,
            defaultStyle: {
              fontSize: 9.5,
            },
            styles: {
              title: {
                fontSize: 16,
                bold: true,
              },
              subtitle: {
                fontSize: 12,
              },
              details: {
                fontSize: 11,
              },
              boldRight: {
                bold: true,
                width: 200,
              },
              tableTitle: {
                fontSize: 14,
                bold: true,
              },
              mainTitle: {
                fontSize: 17,
                bold: true,
              },
              tableFooter: {
                bold: true,
              },
            },
          };
          pdfMake.createPdf(dd).open();
          // }
        }
      });
  }


  konvertiraj(a: any) {
    return this.authService.konvertirajCijenu().konvertiraj(a);
  }

}
